export default __webpack_public_path__ + "static/banner-two-shape7-2de8a1418689d1d30f114430b612ac59.png";